import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  bgColor15,
  blackColor,
  blackShade19,
  blueColor04,
  greyColor40,
  greyColor41,
  greyColor8,
  redColor08,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { textOneLines, textTwoLines } from "../../../utils/styles";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const SyncProductInfoRowCard = ({
  productImg,
  productName,
  skuCode,
  onViewClick,
  tabValue,
  onDelete
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        bgcolor: whiteColor,
        padding: "12px 0",
        borderBottom: `1px solid ${greyColor41}`,
        borderRadius: { xs: "6px", md: "0px" },
        mb: { xs: 1.5, md: 0 },
      }}
    >
      <Grid container rowSpacing={{ xs: 1, md: 0 }}>
        <Grid item xs={1.85} md={0.9}>
          <Box
            display="flex"
            alignItems="flex-start"
            gap={{ xs: 1.5, md: 2 }}
            pl={2}
          >
            <Box sx={styles.imgBox} onClick={onViewClick}>
              <Box component="img" src={productImg} sx={styles.imgContainer} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={10.15} md={8.1}>
          <Box pl={2}>
            <Typography
              sx={{
                ...textTwoLines,
                fontSize: 12,
                fontWeight: 600,
                color: blackColor,
                cursor: "pointer",
              }}
              onClick={onViewClick}
            >
              {productName}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} md={2.1}>
          <Box ml={2}>
            <Typography
              sx={{
                fontSize: { xs: 11, md: 12 },
                fontWeight: 500,
                color: greyColor40,
              }}
            >
              {skuCode}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={0.7}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent={{ xs: "flex-end", md: "flex-start" }}
            p={{ xs: "0 16px 0 0", md: "0 0 0 16px" }}
          >
            {tabValue == 0 ? (
              <Button
                variant="outlined"
                sx={styles.viewBtn}
                onClick={onViewClick}
              >
                VIEW
              </Button>
            ) : (
              <IconButton
                sx={{
                  border: `1px solid ${redColor08}`,
                  borderRadius: "4px",
                  p:'4px 6px',
                  color: redColor08,
                }}
                onClick={onDelete}
              >
                <DeleteOutlineOutlinedIcon color="inherit" sx={{fontSize:'20px'}} />
              </IconButton>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SyncProductInfoRowCard;

const styles = {
  checkbox: {
    p: 0,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  imgBox: {
    borderRadius: "4px",
    border: "1px solid #e5e9f0",
    p: "5px",
    cursor: "pointer",
  },

  imgContainer: {
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "25px", md: "35px !important" },
    height: { xs: "25px", md: "35px !important" },
    objectFit: "contain",
  },

  actionBtn: {
    width: "33px",
    height: "27px",
    fontSize: 12,
    fontWeight: 600,
    padding: "3px 15px",
    textTransform: "unset",
    border: `1px solid ${bgColor15}`,
    borderRadius: "4px",
    color: bgColor15,
    mt: { xs: 0, md: 1.2 },
    "&:hover": {
      color: whiteColor,
      backgroundColor: bgColor15,
    },
    "&.Mui-disabled": {
      borderColor: "rgba(0,0,0,0.2)",
    },
  },

  viewBtn: {
    fontSize: 12,
    fontWeight: 500,
    color: blueColor04,
    borderWidth: "1px",
    borderColor: blueColor04,
    p: "3px 15px",
    "&:hover": {
      borderColor: blueColor04,
      bgcolor: blueColor04,
      color: whiteColor,
    },
  },
};
